import { numberToTimeStringObject } from "../../../utils/stringFormatting";
import "./StatCard.css";
import { Typography, Tooltip } from "@material-ui/core";
import TooltipInfoIcon from "../../../assets/icons/tooltipInfoIconBlackOutline.svg";
import AnimatedNumber from "animated-number-react";

interface StudentHomeScreenStatProps {
  label: string;
  tooltipLabel: string;
  imgAlt: string;
  statsValue: number;
  formatType: "percent" | "time" | "whole";
  postfix?: string;
}

const StatCard = (props: StudentHomeScreenStatProps) => {
  const formatValue = (value: number) => {
    let secondValue: string;
    let postfixString = props.postfix ? ` ${props.postfix}` : "";

    switch (props.formatType) {
      case "percent":
        value = Math.ceil(Math.min(value, 1.0) * 100);
        return "%" + value.toFixed().toString() + postfixString;
      case "time":
        const timeValue = numberToTimeStringObject(value);
        if (timeValue.hours > 0) {
          secondValue = ((timeValue.minutes / 60) * 10).toFixed(0);
          postfixString = "hours" + postfixString;
          return timeValue.hours.toFixed() + "." + secondValue + " hours";
        } else if (timeValue.minutes > 0) {
          secondValue = ((timeValue.seconds / 60) * 10).toFixed(0);
          return timeValue.minutes.toFixed() + "." + secondValue + " minutes" + postfixString;
        } else {
          return timeValue.seconds + " seconds" + postfixString;
        }
      case "whole":
        return Math.ceil(value).toLocaleString("en-US") + postfixString;
    }
  };

  return (
    <div className="statsCard">
      <Typography variant="h6" component="div">
        <div className="statsValue">
          <AnimatedNumber value={props.statsValue} formatValue={formatValue} />
        </div>
      </Typography>
      <Typography variant="body1">
        <div className="statsLabel">
          {props.label}
          <Tooltip title={<span className="StatsCardTooltip">{props.tooltipLabel}</span>}>
            <img src={TooltipInfoIcon} alt={props.imgAlt} height={14} />
          </Tooltip>
        </div>
      </Typography>
    </div>
  );
};

export type { StudentHomeScreenStatProps };
export { StatCard };
